<template>
  <div>
    <NavBar />
    <NewDynamicRoute @created="getDynamicRoutes()" />
    <ViewDynamicRoute
      :dynamic_route_id="dynamic_route_id"
      @updated="getDynamicRoutes()"
    />
    <b-overlay :show="loading" opacity="0.99">
      <b-container>
        <v-card>
          <v-card-title>
            <b-row align-v="center">
              <b-col cols="auto">
                <v-btn
                  class="v-primary"
                  @click="$bvModal.show('new_dynamic_route')"
                >
                  <span class="fa fa-plus mr-1"></span> Novo
                </v-btn>
              </b-col>
              <b-col cols="auto"> Rotas dinâmicas </b-col>
              <b-col>
                <v-text-field
                  class="p-0 m-0"
                  v-model="search"
                  append-icon="mdi-magnify"
                  label="Pesquisar"
                  single-line
                  hide-details
                />
              </b-col>
            </b-row>
          </v-card-title>
          <v-card-text>
            <ErrorsMessages :errors="errors" />
            <b-row>
              <b-col>
                <v-data-table
                  dense
                  :headers="headers"
                  :items="dynamic_routes"
                  :search="search"
                  :footer-props="{
                    'items-per-page-options': [25, 75, 100],
                    'items-per-page-text': 'Mostrar',
                  }"
                  @click:row="openViewModal"
                />
              </b-col>
            </b-row>
          </v-card-text>
        </v-card>
      </b-container>
    </b-overlay>
  </div>
</template>

<script>
import NavBar from "../templates/NavBar";
import ErrorsMessages from "../templates/components/ErrorsMessages";
import NewDynamicRoute from "../templates/dynamic-routes/NewDynamicRoute";
import ViewDynamicRoute from "../templates/dynamic-routes/ViewDynamicRoute";

import api from "../services/api";

import { adminData } from "../lib/functions";

export default {
  name: "DynamicRoutes",
  components: {
    NavBar,
    ErrorsMessages,
    NewDynamicRoute,
    ViewDynamicRoute,
  },
  data() {
    return {
      permissions: {},
      errors: [],

      loading: false,

      search: "",
      headers: [
        { text: "Código", sortable: false, value: "id" },
        { text: "Rota", value: "url" },
      ],
      dynamic_routes: [],
      dynamic_route_id: "",
    };
  },
  created() {
    this.permissions = adminData().permissions;

    this.getDynamicRoutes();
  },
  methods: {
    async openViewModal(item) {
      this.dynamic_route_id = item.id;
      this.$bvModal.show("view_dynamic_route");
    },

    async getDynamicRoutes() {
      try {
        this.loading = true;

        let response = await api.get("/admin/rest-home/dynamic-routes");
        let { error, errors, dynamic_routes } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.dynamic_routes = dynamic_routes;
          this.errors = [];
        }

        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>